import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // jump to the top on every route change
    window.scrollTo({ top: 0, left: 0, behavior: "instant" }); // use "smooth" if you like
  }, [pathname]);
  return null;
}
